var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"pxxy"},_vm._l((_vm.pptList),function(it,i){return _c('div',{key:i,on:{"click":function($event){return _vm.lookPpt(it)}}},[_c('div',{staticClass:"iconfont icon-_kecheng"}),_c('div',[_vm._v(_vm._s(it.name))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_box_tit"},[_c('div',[_vm._v("课程ppt")]),_c('div',{staticClass:"bom_line"})])
}]

export { render, staticRenderFns }